import '../../style/index.less'
import './index.less'



// WEBPACK FOOTER //
// ./components/avatar/style/index.js